import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
 
const container = document.getElementById('root')!;
const root = createRoot(container);
 
root.render(
  // I removed StrictMode because it duplicate calls on Component Load... We can reestablish later with ReactQuery (or other Cache method) set to LTE 2 secs (I dont really want to cache)
  // <React.StrictMode>
	  <App />
  // </React.StrictMode>
);
